import { useEffect } from "react";
import { TableActions } from "../../components/tables/tableContext/TableContext";
import TableWidget from "../../components/tables/TableWidget";
import { getReceipts } from "../../redux/api/receipt.api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import ReceptionActionButtons from "./components/ReceptionActionButtons";
import ReceptionTableActionButtons from "./components/TableActionsButtonsComponents/ReceptionTableActionButtons";
import {
  getReceiptsTableData,
  receiptTableHeader,
} from "./components/tableConfigs/receptionTableConfig";
import { clearAvailableReceiptsList } from "../../redux/reducer/receipt.reducer";

function Reception() {
  const dispatch = useAppDispatch();

  const {
    receipt: {
      avaibleReceiptsList: { isLoadingReceipts, data: receiptsData },
    },
  } = useAppSelector((state) => ({
    receipt: state.receipt,
  }));

  useEffect(() => {
    return () => {
      dispatch(clearAvailableReceiptsList());
    };
  }, [dispatch]);

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      dispatch(
        getReceipts({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          stadiu: action.tableSearch?.stadiu,
          provider: action.tableSearch?.provider,
        }),
      );
    }
  };

  return (
    <div>
      <ReceptionActionButtons />
      <TableWidget
        tableTitle="Receptii"
        tableHeaderData={receiptTableHeader}
        tableItemsData={getReceiptsTableData(receiptsData.receptii)}
        tableLoading={isLoadingReceipts}
        handleTableActions={handleTableActions}
        totalItems={receiptsData.nrTotalReceptii}
        withGlobalSearch={false}
        ActionButtonsComponent={(props: any) => (
          <ReceptionTableActionButtons {...props} />
        )}
      />
    </div>
  );
}

export default Reception;
